export default __webpack_public_path__ + "static/media/price-tag.a6664430.png";